import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import UniqueVoteRow from './UniqueVoteRow'

class UniqueVotes extends Component {
  dismissPopup () {
    this.props.dispatch(actions.switchUniqueVotes({}))
  }

  render () {
    const votes = this.props.payload
    const { players, teams, polls } = this.props

    return (
      <div className='dashboard-popup-notif' >
        <div className='hey-popup-header'>
          <h4 className='header-text'>All Unique Votes</h4>
          <button
            onClick={this.dismissPopup.bind(this)}
            className='black-cross'>
            <img alt='' src='/imgs/close.png' />
          </button>
        </div>
        <div className='votes-header'>
          <div className='cell-name'>Name and team</div>
          <div className='cell-question'>Question</div>
          <div className='cell-answer'>Answer</div>
        </div>
        <div className='line votes-view'>
          <div>
            {votes.map(v =>
              <UniqueVoteRow
                key={v._id}
                vote={v}
                poll={polls.find(p => p._id === v.comment)}
                player={players.find(p => p.id === v.participant)}
                team={teams.find(t => t.id === players.find(p => p.id === v.participant).team)}
              />)}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    payload: state.popup.payload,
    players: state.participants,
    teams: state.team.teams,
    polls: state.comments.polls
  }
}

export default connect(mapStateToProps)(UniqueVotes)



// WEBPACK FOOTER //
// ./src/components/common/popups/UniqueVotes.js